module.exports = __webpack_public_path__ + "media/images/emoticons/bank-752690508de0cdf3cf34fd9a42b6ebe5.gif";